/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';
import { Flexed, ProgressBar } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { formatUSD } from '../../helpers/helperFunctions';
import { Circle } from '../Ranking/RankingStyled';
import { PackageTrading } from './Portfolio.types';

export const PortfolioItem = ({ item }: { item: PackageTrading }) => {
  const { t } = useTranslation('my_hubs');

  const getDepositPercentage = (
    depositedAmount: number | null | undefined,
    depositLimit: number | null | undefined
  ) => {
    if (!depositedAmount || !depositLimit) {
      return 0;
    } else {
      return Math.round((depositedAmount / depositLimit) * 100);
    }
  };

  return (
    <>
      <BoxBig relative dark>
        <HubImage image={item.image}>
          {/* <H4 color={color.colors.neutral0}>{item.name}</H4> */}
        </HubImage>
        <Flexed column between>
          <H4 mb='20' color={color.colors.neutral0}>
            {item.name}
          </H4>
          <div>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                transform: 'translate(-50%, -50%)'
              }}>
              <Spinner />
            </div>

            <Tr style={{ cursor: 'pointer' }}>
              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral0} mb='10'>
                  {t('price')}
                </CaptionText>
                <P1 bold flex alignEnd gap='5px' color={color.colors.neutral0}>
                  {item.price} <P3 mb='3'>USDT</P3>
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral0} mb='10'>
                  {t('date_of_purchase')}
                </CaptionText>
                <P1 bold color={color.colors.neutral0}>
                  {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                </P1>
              </Td>

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral0} mb='10'>
                  {t('order_id')}:
                </CaptionText>
                <P1 bold color={color.colors.neutral0}>
                  {item?.id}
                </P1>
              </Td>

              {/* <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                  {t('nft_id')}:
                </CaptionText>
                <P1 bold>{item?.nftId}</P1>
              </Td> */}

              <Td w='20%' wSM='50%'>
                <CaptionText caps bold color={color.colors.neutral0} mb='10'>
                  Status
                </CaptionText>
                <Flexed center>
                  <P3 bold caps color={color.colors.neutral0}>
                    {item?.isActive ? t('active') : t('inactive')}
                  </P3>
                  <Circle
                    color={
                      item?.isActive
                        ? color.colors.success500
                        : color.colors.error500
                    }
                  />
                </Flexed>
              </Td>
            </Tr>
          </div>
          {/* 
          <Flexed></Flexed>

          <Tr>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                amount minted
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(item?.mintedAmount || 0)} {item?.mintedTokenCurrency}
              </P1>
            </Td>
          </Tr> */}

          <Flexed rowSM mt='30'>
            <Flexed column width='50%' widthSM='100%'>
              <Flexed between center>
                <Flexed center gap='5px'>
                  <CaptionText caps bold color={color.colors.neutral0}>
                    Current Deposit
                  </CaptionText>
                  <P2 semiBold color={color.colors.neutral0}>
                    {item?.depositedAmount
                      ? formatUSD(item?.depositedAmount)
                      : 0}
                  </P2>
                </Flexed>
                <Flexed center gap='5px'>
                  <CaptionText caps bold color={color.colors.neutral0}>
                    Max deposit
                  </CaptionText>
                  <P2 semiBold color={color.colors.neutral0}>
                    {' '}
                    {item?.depositLimit ? formatUSD(item?.depositLimit) : 0}
                  </P2>
                </Flexed>
              </Flexed>

              <ProgressBar
                percentage={`${getDepositPercentage(
                  item?.depositedAmount,
                  item?.depositLimit
                )}%`}
                percentageLabel>
                <div></div>
                <span>
                  {' '}
                  {getDepositPercentage(
                    item?.depositedAmount,
                    item?.depositLimit
                  )}
                  %
                </span>
              </ProgressBar>
            </Flexed>
          </Flexed>
        </Flexed>
        {/* <Flexed column justifyCenter widthSM='100%'>
          <Link to={`${MANAGE_AKASHA_NODE}/${item.id}`}>
            <Button mr='20' w='200px' wSM='100%' disabled={!item?.nftId}>
              Manage
            </Button>
          </Link>
        </Flexed> */}
      </BoxBig>
    </>
  );
};
